// Action value in hit
export var HIT_ACTION_NAME = 'component-spenttime';
// The time (ms) we wait for the DOT to load
export var DOT_WAITING_TIME = 10000;
// Delaytime of user activity events
export var THROTTLE_DELAY = 1000; // 1s
// Device type
// eslint-disable-next-line no-shadow
export var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["DESKTOP"] = "desktop";
    DEVICE_TYPE["MOBILE"] = "mobile";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
export var ITEM_MONITORED_ATTRIBUTE = 'data-analytics-spent-time-item-monitored';
export var DEFAULT_CONFIG = {
    container: {
        // Intersection threshold of target element
        intersectionThreshold: 0.05, // 5%
    },
    mobile: {
        measuring: true,
        // User inactivity time, after which we pause the spentime calculation (the user fell asleep)
        fallAsleepTime: 15000, // (milliseconds) 15 seconds
        // User inactivity time, after which we stop counting the time spent (the user has left)
        forcedDepartureTime: 30 * 60 * 1000, // (ms) 30 minut
    },
    desktop: {
        measuring: true,
        // User inactivity time, after which we pause the spentime calculation (the user fell asleep)
        fallAsleepTime: 45000, // (milliseconds) 45 seconds
        // User inactivity time, after which we stop counting the time spent (the user has left)
        forcedDepartureTime: 30 * 60 * 1000, // (ms) 30 minut
    },
};
export var DEFAULT_ITEMS_CONFIG = {
    numberOfItemsInHit: 20,
    attributeWithDopDetails: null,
    mobile: {
        // The delay time on desktop devices
        measurementStartDelay: 500, // (ms) 0.5s
        // Intersection threshold of target element in target area
        intersectionThreshold: 0.75, // 75%
        // the screen area where the user reads articles
        targetAreaHeight: 1.0, // 100%
        targetAreaWidth: 1.0, // 100%
    },
    desktop: {
        // The delay time on desktop devices
        measurementStartDelay: 1000, // (ms) 1s
        // Intersection threshold of target element in target area
        intersectionThreshold: 0.75, // 75%
        // the screen area where the user reads articles
        targetAreaHeight: 1.0, // 100%
        targetAreaWidth: 1.0, // 100%
    },
};
// eslint-disable-next-line no-shadow
export var EVENT;
(function (EVENT) {
    EVENT["measurementWillNotBePerformed"] = "szn:spenttime:measurementWillNotBePerformed";
    EVENT["waitingForDot"] = "szn:spenttime:waitingForDot";
    EVENT["stateInited"] = "szn:spenttime:stateInited";
    EVENT["stateRun"] = "szn:spenttime:stateRun";
    EVENT["statePaused"] = "szn:spenttime:statePaused";
    EVENT["stateDone"] = "szn:spenttime:stateDone";
})(EVENT || (EVENT = {}));
// Measurement spenttime states
// eslint-disable-next-line no-shadow
export var SPENTTIME_STATES;
(function (SPENTTIME_STATES) {
    SPENTTIME_STATES["inited"] = "inited";
    SPENTTIME_STATES["running"] = "running";
    SPENTTIME_STATES["paused"] = "paused";
    SPENTTIME_STATES["done"] = "done";
})(SPENTTIME_STATES || (SPENTTIME_STATES = {}));
